import React from "react";
import ModalClientsTheme from "./ModalClients.styles";
import { Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ExportarPlanilha from "../components/ExportaPlanilha";
import MeuModal from "../components/MeuModal";
import { Tabela } from "./Tabela";
import Titulo from "../components/Titulo";

const ModalClients = (props) => {

  const styles = ModalClientsTheme();
  let allowActions = (props.title === 'Clientes com implantação pendente') ? true : false;

  return (
    <MeuModal open={props.open} onClose={props.handleClose} altura="90%" largura="80%">
        <Titulo title={props.title} alignItems="center" />
        <div style={{ height: "82%" }}>
          <Tabela tabelaAtual={props.clients} allowActions={allowActions} cardTitle={props.title}/>
        </div>
        <div className={styles.botoes}>
          <Button
            style={{ marginRight: "8px" }}
            startIcon={<CloseIcon />}
            variant="outlined"
            color="primary"
            onClick={props.handleClose}
          >
            Fechar
          </Button>
          <ExportarPlanilha nomeTabela={props.title} rows={props.rows} />
        </div>
      </MeuModal>
  );
};

export default ModalClients;
